import React from "react";
import { Pagination } from "react-bootstrap";
import "../Styles/pagination.css";
const BSPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  siblingCount = 1,
  showFirstLast = true,
}) => {
  const generatePages = () => {
    const pages = [];
    const startPage = Math.max(currentPage - siblingCount, 1);
    const endPage = Math.min(currentPage + siblingCount, totalPages);

    if (showFirstLast && startPage > 1) {
      pages.push(1);
      if (startPage > 2) pages.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (showFirstLast && endPage < totalPages) {
      if (endPage < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  const handlePageChange = (page) => {
    if (page !== "..." && page !== currentPage) {
      onPageChange(page);
    }
  };

  const pages = generatePages();

  return (
    <Pagination className="pagination-dark justify-content-center">
      <Pagination.Prev
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
      {pages.map((page, index) =>
        page === "..." ? (
          <Pagination.Ellipsis key={index} disabled />
        ) : (
          <Pagination.Item
            key={index}
            active={page === currentPage}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </Pagination.Item>
        )
      )}
      <Pagination.Next
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    </Pagination>
  );
};

export default BSPagination;
